import { render } from "./SurveyQ3.vue?vue&type=template&id=a44d945c&ts=true"
import script from "./SurveyQ3.vue?vue&type=script&lang=ts"
export * from "./SurveyQ3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__